import React from 'react';

export const CardLeaderboard = (
  {
    bigImg,
    index,
    title,
    description,
    directory,
    wrapperStyle = {},
    indexStyle = {},
  },
) => {
  return (
    <div
      className='card-leaderboard-wrapper'
      style={wrapperStyle}
    >
      <div className='card-leaderboard-img_index_title'>
        {bigImg ?
          <div className='card-leaderboard-big-img'>
            {bigImg && <img src={bigImg} alt='card' />}
          </div>
          :
          <div
            className='card-leaderboard-index'
            style={indexStyle}
          >
            #{index}
          </div>
        }
        <div className='card-leaderboard-title-description'>
          {title &&
            <h4 className={bigImg ? 'card-leaderboard-title-big' : 'card-leaderboard-title-small'}>
              {title}
            </h4>
          }
          {description &&
            <p className='card-leaderboard-description'>
              {description}
            </p>
          }
        </div>
      </div>
      {directory &&
        <p className='card-leaderboard-directory'>
          {directory}
        </p>
      }
    </div>
  );
};

